import {AppModals, useAppModalState} from '@src/AppModals'
import {AtalayaWrapper} from '@therms/atalaya'
import {
  AppWrapper2,
  DownloadsApiServiceContextProvider,
  RecordsFieldOptionsConfigProvider,
  resolveFileName,
  RouterContextProvider,
  RPCContextProvider,
  rpcResponseInterceptorLogger,
} from '@therms/react-modules'
import {RPCClientOptions, TransportType} from '@therms/rpc-client'
import {createBrowserHistory} from 'history'
import {StrictMode} from 'react'
import {Router} from 'react-router-dom'
import {GLOBALS} from '../build-env'
import {AppRouter} from './AppRouter'
import {DownloadsApiClientConfig} from '@therms/downloads-api'

const rpcOptions: RPCClientOptions = {
  hosts: {
    http: GLOBALS.RPC_HTTP_HOST,
    websocket: GLOBALS.RPC_WS_HOST,
  },
  responseInterceptor: rpcResponseInterceptorLogger,
  transportOptions: {
    preferredTransport: TransportType.http,
  },
}

const downloadsApiConfig: DownloadsApiClientConfig = {
  basePath: GLOBALS.BASE_DOWNLOADS_API_URL,
  hooks: {
    onError: (context) => {
      // todo: need to log errors and send to sentry
    },
  },
}

console.log('Build:', GLOBALS.BUILD_DATE, 'RPC HOSTS', rpcOptions.hosts)

export const history = createBrowserHistory({basename: '/portal'})

export function App() {
  const appModalState = useAppModalState()

  return (
    <StrictMode>
      <RPCContextProvider options={rpcOptions}>
        <DownloadsApiServiceContextProvider clientConfig={downloadsApiConfig}>
          <RouterContextProvider history={history}>
            <AtalayaWrapper resolveFileName={resolveFileName}>
              <AppWrapper2
                appInteractionHandlers={{
                  onClickEvent: (eventId) =>
                    appModalState.setShowEventModal(eventId),
                  onClickLocation: (locationId) =>
                    appModalState.setShowLocationModal(locationId),
                  onClickLocationLogEntry: (entryId) =>
                    appModalState.setShowLocationLogEntryModal(entryId),
                  onClickRecord: (recordId) =>
                    appModalState.setShowRecordModal(recordId),
                  onClickReport: (reportId) =>
                    appModalState.setShowReportModal(reportId),
                }}
                currentAppId="portal"
                currentAppVersion={GLOBALS.BUILD_DATE}
                mapboxToken={GLOBALS.MAPBOX_ACCESS_TOKEN}
                scopeAllRegions
              >
                <RecordsFieldOptionsConfigProvider>
                  <Router history={history}>
                    <AppRouter />

                    <AppModals />
                  </Router>
                </RecordsFieldOptionsConfigProvider>
              </AppWrapper2>
            </AtalayaWrapper>
          </RouterContextProvider>
        </DownloadsApiServiceContextProvider>
      </RPCContextProvider>
    </StrictMode>
  )
}
